import React, { useEffect, useRef } from 'react';
import Gameprovider from 'react-gamepad';
import * as actionTypes from '../../redux/actionTypes';
import { useDispatch } from 'react-redux';
import { getActiveGamepad } from '@utils/gamepad/getActiveGamepad';

const Gamepad = ({ children }) => {
    const dispatch = useDispatch();

    const connectHandler = () => {
        dispatch({
            type: actionTypes.CONNECTION_ROBOT,
            payload: { robotConnect: 'Connected', connectionColor: '#00ebdc' }
        })
    };

    const disconnectHandler = () => {
        dispatch({
            type: actionTypes.CONNECTION_ROBOT,
            payload: { robotConnect: `Disconnected`, connectionColor: '#FF0000' }
        })
    };

    const axisChangeHandler = (axisName, value) => {
        if (axisName === 'LeftStickY' && value === 1) {
            document.getElementById("forward_button")?.setAttribute("fill", "white");
        } else if (axisName === 'LeftStickY' && value === -1) {
            document.getElementById("backward_button")?.setAttribute("fill", "white");
        } else if (axisName === 'RightStickX' && value === 1) {
            document.getElementById("turn_right_button")?.setAttribute("fill", "white");
        } else if (axisName === 'RightStickX' && value === -1) {
            document.getElementById("turn_left_button")?.setAttribute("fill", "white");
        } else {
            document.getElementById("forward_button")?.setAttribute("fill", "transparent");
            document.getElementById("backward_button")?.setAttribute("fill", "transparent");
            document.getElementById("turn_right_button")?.setAttribute("fill", "transparent");
            document.getElementById("turn_left_button")?.setAttribute("fill", "transparent");

        }
    }

    // Track the last dispatched connection state so we only dispatch on change.
    const connectedRef = useRef(null);

    useEffect(() => {
        if (!('getGamepads' in navigator)) {
            console.log('Gamepad API not supported');
            return;
        }

        // Poll for the first *connected* pad regardless of which slot the
        // browser assigned it to. react-gamepad's onConnect only watches
        // index 0, and the native `gamepadconnected` event is a one-shot that
        // is easily missed (already fired / wrapper mounted late), so a pad at
        // index 1/2/3 would otherwise never flip the card to "Connected".
        const syncConnection = () => {
            const isConnected = !!getActiveGamepad();
            if (connectedRef.current === isConnected) return;
            connectedRef.current = isConnected;
            dispatch({
                type: actionTypes.CONNECTION_ROBOT,
                payload: isConnected
                    ? { robotConnect: 'Connected', connectionColor: '#00ebdc' }
                    : { robotConnect: 'Disconnected', connectionColor: '#FF0000' },
            });
        };

        // Native events give an instant response; polling covers the cases the
        // events miss (any-slot pad, already-fired connect, late mount).
        window.addEventListener('gamepadconnected', syncConnection);
        window.addEventListener('gamepaddisconnected', syncConnection);
        const intervalId = setInterval(syncConnection, 250);
        syncConnection();

        return () => {
            window.removeEventListener('gamepadconnected', syncConnection);
            window.removeEventListener('gamepaddisconnected', syncConnection);
            clearInterval(intervalId);
        };
    }, [dispatch]);

    return (
        <Gameprovider
            onConnect={connectHandler}
            onDisconnect={disconnectHandler}
            onAxisChange={axisChangeHandler}
        >
            <>
                {children}
            </>
        </Gameprovider>
    )
}


export default Gamepad;